<template>
  <div v-if="max > 0" id="c-related" class="c-related">
    <div class="c-related__title f-ITC-BoldIt">
      <h1>
        <img :src="`${assets_path}img/common/logo-pics-b.svg`" alt="P.I.C.S" width="" height="">
        <span>RELATED</span>
      </h1>
      <p>P.I.C.S. is the creative company<br>to disrupt, inspire, and entertain the world</p>
    </div>

    <!-- PC版 -->
    <div class="c-related__wrap" v-show="ispc" :class="{'c-related__wrap--show': isShow}">
      <div ref="parentCircle" class="c-relatedCircle c-relatedCircle--parent">
        <div class="c-relatedCircle__lines">
          <div v-for="(c, index) in params.child" ref="childLine" :key="index" class="c-relatedCircle__linesChild"><div></div></div>
        </div>

        <div class="c-relatedCircle__bg js-hoverBg">
          <svg class="c-relatedCircle__bgMain js-hoverBgMain" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
        </div>
        <div class="c-relatedCircle__photo js-hoverPhoto">
          <div v-if="params.parent.img" class="c-relatedCircle__photoInner" :style="`background-image: url(${params.parent.img});`"></div>
          <div v-if="!params.parent.img" class="c-relatedCircle__photoInner c-relatedSpCircle__photoInner--noimg"></div>
        </div>
        <div class="c-relatedCircle__text">
          <p class="f-ITC-BoldIt" v-html="params.parent.title"></p>
        </div>
      </div>

      <a v-for="(c, index) in params.child" ref="childCircle" :key="index" class="c-relatedCircle c-relatedCircle--child" :href="c.url">
        <div class="c-relatedCircle__bg js-hoverBg">
          <svg class="c-relatedCircle__bgMain js-hoverBgMain" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
        </div>
        <div class="c-relatedCircle__photo js-hoverPhoto">
          <div v-if="c.img" class="c-relatedCircle__photoInner" :style="`background-image: url(${c.img});`"></div>
          <div v-if="!c.img" class="c-relatedCircle__photoInner c-relatedSpCircle__photoInner--noimg"></div>
        </div>
        <div class="c-relatedCircle__text">
          <p class="f-ITC-BoldIt" v-html="c.title"></p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import ResizeObserver from 'resize-observer-polyfill';
  import { assets_path, breakpoint } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';
  import {TweenMax, Cubic} from 'gsap/all';
  import hoverRelated from '@/_modules/common/hoverRelated';

  export default {
    data() {
      return {
        assets_path: assets_path,
        ispc: false,
        isShow: false,
        urls: {},
        params: {},
        max: 0,
        center: {
          x: 0,
          y: 0
        },
        rect: {},
        positions: [],
        parentHover: null,
        hovers: [],
        rectParent: {},
        rectChild: {},
        sizeParent: 240,
        sizeChild: 240,
        posY: null,
        maxDistanceX: 0,
        maxDistanceY: 0,
        wrapper: null
      }
    },
    store,
    created() {

    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-related').textContent);
      this.max = this.params.child.length;

      if (this.max > 0) {
        this.wrapper = document.getElementById('c-wrapper');
        this.$nextTick(this.start);
      }
    },
    methods: {
      onResizeObserver(entries) {
        this.resize();
      },
      start() {
        // オブザーバインスタンスを作成
        this.observer = new ResizeObserver(this.onResizeObserver);
        this.observer.observe(this.wrapper);

        this.setting();
        this.scroll();
        window.addEventListener('scroll', this.scroll);
        //window.addEventListener('resize', this.resize);
      },
      show() {
        for (let i = 0; i < this.max; i++) {
          // 初期の角度
          const degree = this.initDegree(i);
          // 楕円形に配置（座標を求める）
          let ovalPosition = this.$_getOvalPosition(
            degree,
            this.$_random(this.rectParent.width * 1.5, this.maxDistanceX),
            this.maxDistanceY,
            this.center.x,
            this.center.y
          );

          // 各円の数値（角度は計算後に反転している）
          const position = {
            degree: 180 + this.$_rad2deg(this.$_pos2radian(ovalPosition, this.center)),
            distance: this.$_pos2dist(ovalPosition, this.center),
            x: ovalPosition.x,
            y: ovalPosition.y
          };

          // 円の数値を配列にする
          this.positions[i] = position;

          // 縁を結ぶライン
          TweenMax.set(this.$refs['childLine'][i], {
            visibility: 'visible',
            rotate: position.degree,
            width: position.distance
          });

          TweenMax.set(this.$refs['childLine'][i].querySelector('div'), {
            x: -position.distance
          });
        }

        // 親）円を配置
        this.parentHover = new hoverRelated(this.$refs['parentCircle'], 0, this.center, false);
        // 子）円を配置
        this.$refs['childCircle'].forEach((el, index) => {
          this.hovers[index] = new hoverRelated(el, index, this.center, this.positions[index], true);
        });

        this.showComp();
      },
      showComp() {
        this.parentHover.start(false);
        this.hovers.forEach((h, i) => {
          h.start(true, this.positions[i]);

          TweenMax.to(this.$refs['childLine'][i].querySelector('div'), 0.6, {
            delay: 0.1 * i,
            x: 0
          });
        });
      },
      setting() {
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
        } else {
          this.ispc = false;
        }

        this.rectParent = {
          height: this.sizeParent,
          width: this.sizeParent
        };

        if (this.ispc) {
          // relatedコンテンツのトップ位置
          this.posY = this.$_getOffset(this.$el).top - (window.innerHeight * 0.4);
          // relatedコンテンツのサイズ
          const rectMain = this.$el.getBoundingClientRect();
          // 円のサイズ
          //this.rect = this.$refs['parentCircle'].getBoundingClientRect();

          let adjust = 0;
          if (this.ispc) {
            adjust = 280;
          } else {
            adjust = 100;
          }

          this.maxDistanceX = (this.$_getBodyWidth() - adjust) / 2;
          this.maxDistanceY = (rectMain.height - adjust) / 2;
        }
      },
      setPosition() {
        if (this.ispc) {
          for (let i = 0; i < this.max; i++) {
            // 初期の角度
            const degree = this.initDegree(i);
            // 楕円形に配置（座標を求める）
            let ovalPosition = this.$_getOvalPosition(
              degree,
              this.$_random(this.rectParent.width * 1.5, this.maxDistanceX),
              this.maxDistanceY,
              this.center.x,
              this.center.y
            );

            // 各円の数値（角度は計算後に反転している）
            const position = {
              degree: 180 + this.$_rad2deg(this.$_pos2radian(ovalPosition, this.center)),
              distance: this.$_pos2dist(ovalPosition, this.center),
              x: ovalPosition.x,
              y: ovalPosition.y
            };

            this.positions[i] = position;

            TweenMax.set(this.$refs['childLine'][i], {
              rotate: position.degree,
              width: position.distance
            });
          }

          // 親）円は常にセンター0,0なので実行しない
          //this.parentHover.resize(this.center);
          // 子）円の位置再設定
          this.hovers.forEach((h, index) => {
            h.resize(this.center, this.positions[index]);
          });
        }
      },
      scroll() {
        if (this.ispc && this.posY < this.$_currentScrollY()) {
          this.isShow = true;
          window.removeEventListener('scroll', this.scroll);

          // related表示
          this.$nextTick(this.show);
        }
      },
      resize() {
        // 数値リセット
        this.setting();

        if (!this.isShow) {
          this.scroll();
        } else {
          // 円の位置を再設定
          this.setPosition();
        }
      },
      initDegree(i) {
        return -70 + ((270 / this.max) * i) - this.$_randomInt(-8, 8);
      },
      /*
      imgloaded(e) {
        if (e.target.naturalWidth  / e.target.naturalHeight > 1) {
          e.target.style.height = '100%';
          e.target.style.width = 'auto';
        } else {
          e.target.style.height = 'auto';
          e.target.style.width = '100%';
        }
      }
      */
    }
  }
</script>
